import React, { useEffect } from 'react'
import { theme } from '../../styles/theme'

import { Container, Info } from './styles'

type IProps = {
  isShowing: boolean;
  setIsShowing: (state: boolean) => void;
  text: string;
  type: 'success' | 'error' | 'alert';
}

const colorMapper = {
  success: theme.colors.green,
  error: theme.colors.redLight,
  alert: theme.colors.yellow,
}

const Snackbar = ({
  isShowing,
  setIsShowing,
  text,
  type,
}: IProps) => {
  useEffect(() => {
    const timer = isShowing && setTimeout(() => {
      setIsShowing(false)
    }, 3000)

    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [isShowing, setIsShowing])

  return (
    <Container>
      <Info
        isShowing={isShowing}
        style={{ backgroundColor: colorMapper[type] }}
      >
        {text}
      </Info>
    </Container>
  )
}

export default Snackbar
